module.exports = __webpack_public_path__ + "media/site_templates/www.localconcreters.com.au/images/feature_2-0a8bd5193acd704dac5f77bf715f1229.jpeg";